var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnstable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unstable",
    transform: "translate(-3.48 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(3.48 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M18.46,46.521a3.06,3.06,0,1,0-3.06-3.06,3.063,3.063,0,0,0,3.06,3.06",
    transform: "translate(-15.4 -31.46)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M72.674,47.749a2.374,2.374,0,1,1,2.374-2.374,2.365,2.365,0,0,1-2.374,2.374",
    transform: "translate(-51.049 -33.374)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M63.674,11.249a2.374,2.374,0,1,1,2.374-2.374,2.4,2.4,0,0,1-2.374,2.374",
    transform: "translate(-44.421 -6.5)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M63.674,79.5a2.374,2.374,0,1,0,2.374,2.374A2.416,2.416,0,0,0,63.674,79.5",
    transform: "translate(-44.421 -60.249)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M27.717,62.719a10.663,10.663,0,0,0,8.721,6.937",
    transform: "translate(-23.683 -48.176)",
    fill: "none",
    stroke: "#c9d3f2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M51.046,84.062,47.564,82.4,47.3,85.038Z",
    transform: "translate(-35.046 -62.384)",
    fill: "#c9d3f2"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linea_1",
    "data-name": "Linea 1",
    x2: 11,
    transform: "translate(8.98 12.093)",
    fill: "none",
    stroke: "#c9d3f2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M59.823,48.368,56.6,47.2v2.335Z",
    transform: "translate(-37.633 -36.274)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M53.635,14.8,51.3,15.968l1.354,1.261Z",
    transform: "translate(-34.156 -12.437)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    transform: "translate(7.536 3.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M31.048,26.492a.843.843,0,0,1,1.252-.184c.841.514,1.378.093,1.051-.841s.21-1.354,1.051-.841,1.378.093,1.051-.841.21-1.354,1.051-.841,1.378.093,1.051-.841c-.187-.514-.093-.887.163-1s.616-.057.957.655.784.349.784.349l.188-1.484,1.2.267c.217.021.712-.722.712-.722",
    transform: "translate(-31.048 -20.166)",
    fill: "none",
    stroke: "#c9d3f2",
    strokeWidth: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstable);
export default __webpack_public_path__ + "static/media/Unstable.5a00865ff0f5e192999a64abe2d37ae7.svg";
export { ForwardRef as ReactComponent };